/* Lumistelle Wishlist — client module.
   Phase 1: heart-fill on load + on append. Decoupled from the carousel engine.
   Source of truth: SSR emit (window.LumistelleWishlist.ids) when logged in,
   localStorage when guest. Match key: data-product on the heart button.
   Reuses .iwishAdded so the existing saved-icon swap keeps working.
   Add-only during iWish coexistence (never strips iWish's own hearts). */
(function () {
  'use strict';

  var WL = (window.LumistelleWishlist = window.LumistelleWishlist || {});
  WL.ids = Array.isArray(WL.ids) ? WL.ids.map(String) : [];
  // v2 stores {id, handle} — the handle is required to fetch the card.
  // v1 (bare ids) can't be rendered, so it's dropped outright on first load.
  var GUEST_KEY = 'lumistelle_wishlist_guest_v2';
  try { localStorage.removeItem('lumistelle_wishlist_guest'); } catch (e) {}

  function guestItems() {
    try {
      var arr = JSON.parse(localStorage.getItem(GUEST_KEY) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (o) { return o && o.id && o.handle; })
                .map(function (o) { return { id: String(o.id), handle: String(o.handle) }; });
    } catch (e) { return []; }
  }
  function saveGuestItems(items) {
    try { localStorage.setItem(GUEST_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function guestIds() { return guestItems().map(function (o) { return o.id; }); }

  WL.activeIds = function () { return WL.loggedIn ? WL.ids : guestIds(); };
  WL.isWishlisted = function (id) { return WL.activeIds().indexOf(String(id)) !== -1; };

  function markButton(btn) {
    var pid = btn.getAttribute('data-product');
    if (pid && WL.isWishlisted(pid)) btn.classList.add('lumi-wishlisted');
  }

  WL.fill = function (root) {
    root = root || document;
    var btns = root.querySelectorAll('.lumistelle-carousel__wishlist[data-product]');
    for (var i = 0; i < btns.length; i++) markButton(btns[i]);
  };

  // Watch real card parents for appended cards — no engine coupling, no
  // hardcoded container class.
  function observeAppends() {
    if (!('MutationObserver' in window)) return;
    var seen = [];
    var cards = document.querySelectorAll('.lumistelle-carousel__product');
    for (var i = 0; i < cards.length; i++) {
      var p = cards[i].parentElement;
      if (p && seen.indexOf(p) === -1) seen.push(p);
    }
    if (!seen.length) return;
    var obs = new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.lumistelle-carousel__wishlist[data-product]')) {
            markButton(node);
          } else if (node.querySelectorAll) {
            WL.fill(node);
          }
        }
      }
    });
    for (var c = 0; c < seen.length; c++) obs.observe(seen[c], { childList: true, subtree: true });
  }

  // ---- Interaction (Phase 2): our handler solely owns the heart click ----
  var DEBOUNCE_MS = 450;
  var MAX_RETRIES = 4;
  var LIST_MAX = 128;        // Shopify's list metafield cap
  var pending = {}; // id -> { desired, timer }

  // ---- Guest visitor token + save signal ----
  // Identity-free browser token, kept in localStorage beside the guest list so a
  // storage wipe clears both together (new visitor, empty list — coherent).
  // Nothing stores it server-side yet; the consumer is the deferred metaobject phase.
  var VISITOR_KEY = 'lumistelle_visitor_v1';

  function newToken() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      if (window.crypto && crypto.getRandomValues) {   // randomUUID sits exactly on the iOS 15.4 floor
        var b = new Uint8Array(16);
        crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
        var h = [];
        for (var i = 0; i < 16; i++) h.push((b[i] + 0x100).toString(16).slice(1));
        return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' +
               h.slice(6, 8).join('') + '-' + h.slice(8, 10).join('') + '-' + h.slice(10, 16).join('');
      }
    } catch (e) {}
    return 'f' + Date.now().toString(16) + Math.random().toString(16).slice(2, 10);
  }

  function visitorToken() {
    try {
      var t = localStorage.getItem(VISITOR_KEY);
      if (t && /^[0-9a-zA-Z-]{8,64}$/.test(t)) return t;
      t = newToken();
      localStorage.setItem(VISITOR_KEY, t);
      return t;
    } catch (e) { return ''; }
  }

  // Fire-and-forget, never touches the UI. keepalive so a heart-then-navigate
  // still lands. Retry budget deliberately smaller than the wishlist write —
  // a lost analytics event costs a count, not a customer's list.
  function postGuestEvent(action, id, tries) {
    fetch('/apps/wishlist/event', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, product_id: id, visitor_token: visitorToken() })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (d && d.ok) return;
        if (r.status === 401) return;          // bad_signature: stop
        throw new Error('event_failed');
      });
    }).catch(function () {
      if (tries < 2) setTimeout(function () { postGuestEvent(action, id, tries + 1); }, 800 * (tries + 1));
    });
  }

  function setLocal(id, saved, handle) {
    id = String(id);
    if (WL.loggedIn) {
      var i = WL.ids.indexOf(id);
      if (saved && i === -1) WL.ids.unshift(id);        // recent-first, matching the Worker
      else if (!saved && i !== -1) WL.ids.splice(i, 1);
    } else {
      var items = guestItems(), j = -1;
      for (var k = 0; k < items.length; k++) { if (items[k].id === id) { j = k; break; } }
      if (saved) {
        if (j !== -1) items.splice(j, 1);
        if (handle) items.unshift({ id: id, handle: handle });
      } else if (j !== -1) {
        items.splice(j, 1);
      }
      saveGuestItems(items);
    }
  }

  // Reflect saved state on every rendered heart for this product.
  function paintButtons(id, saved) {
    var btns = document.querySelectorAll('.lumistelle-carousel__wishlist[data-product="' + id + '"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('lumi-wishlisted', saved);
      btns[i].setAttribute('aria-pressed', saved ? 'true' : 'false');
      btns[i].setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  // Undo an optimistic add the server refused.
  function revertAdd(id) {
    id = String(id);
    var i = WL.ids.indexOf(id);
    if (i !== -1) WL.ids.splice(i, 1);
    paintButtons(id, false);
    removeFromModal(id);
    updateCount();
  }

  function notice(msg) {
    var el = document.getElementById('lumi-wl-notice');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lumi-wl-notice';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:11000;' +
        'max-width:82vw;padding:12px 18px;border-radius:8px;background:#fffdfa;color:#3B2316;' +
        'font-family:var(--font-heading-family,serif);font-size:14px;line-height:1.35;text-align:center;' +
        'pointer-events:none;opacity:0;transition:opacity .25s ease;' +
        'box-shadow:0 2px 6px rgba(59,35,22,.18),0 6px 16px rgba(59,35,22,.14);';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.opacity = '0'; }, 4000);
  }

  function post(action, id, tries) {
    fetch('/apps/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, product_id: id })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (d && d.ok) return;            // success
        if (d && d.error === 'list_full') {   // don't leave a heart claiming it saved
          revertAdd(id);
          notice('Your wishlist holds ' + (d.limit || LIST_MAX) + ' pieces. Remove one to save another.');
          return;
        }
        if (r.status === 401) return;     // not_logged_in / bad_signature: stop; SSR reconciles
        throw new Error('write_failed');  // transient/server: retry
      });
    }).catch(function () {
      if (tries < MAX_RETRIES) {
        setTimeout(function () { post(action, id, tries + 1); }, 500 * Math.pow(2, tries));
      }
      // optimistic state kept regardless; next SSR load reconciles
    });
  }

  function flush(id) {
    var p = pending[id];
    if (!p) return;
    delete pending[id];
    if (WL.loggedIn) {
      post(p.desired ? 'add' : 'remove', id, 0);
    } else if (p.desired !== p.was) {
      // Guests: localStorage already holds the list. The only network call is
      // the identity-free save signal, and only on a real state transition.
      postGuestEvent(p.desired ? 'save' : 'unsave', id, 0);
    }
  }

  // Debounced, coalescing toggle — rapid clicks resolve to the final state, one write.
  function toggle(id, handle) {
    id = String(id);
    var desired = !WL.isWishlisted(id);
    if (desired && !WL.loggedIn && guestItems().length >= LIST_MAX) {
      notice('Your wishlist holds ' + LIST_MAX + ' pieces. Remove one to save another.');
      return;                        // cap guests too, so a later merge can't truncate
    }
    setLocal(id, desired, handle);   // optimistic data
    // Read back rather than trusting intent. If the write couldn't persist
    // (guest save with no handle), a heart painted "saved" can never be undone,
    // because the next click recomputes desired from state that never changed.
    var actual = WL.isWishlisted(id);
    paintButtons(id, actual);
    updateCount();                      // keep the header badge in sync
    if (actual !== desired) return;     // nothing stored: don't sync or signal
    if (desired) addToModal(id, handle); else removeFromModal(id);  // reflect the change in the loaded modal live
    // Guests only, saves only. The tip module isn't rendered at all for a
    // signed-in customer, so the loggedIn check is belt and braces.
    if (desired && !WL.loggedIn && window.LumiWishlistTip) window.LumiWishlistTip.show();
    // Remember the state this burst STARTED from. The counter is not idempotent,
    // so a save-then-unsave inside one debounce window must send nothing at all.
    var was = pending[id] ? pending[id].was : !desired;
    if (pending[id] && pending[id].timer) clearTimeout(pending[id].timer);
    pending[id] = { desired: desired, was: was, timer: setTimeout(function () { flush(id); }, DEBOUNCE_MS) };
  }

  function wireClicks() {
    // Capture + stopPropagation neutralizes iWish's own click handler (however
    // it binds), so our system alone owns the heart during coexistence.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.lumistelle-carousel__wishlist') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-product');
      // Handle: lite-card root, else any quick-view attr, else the title link.
      var card = btn.closest('.lumistelle-carousel__product');
      var handle = card ? (card.getAttribute('data-handle') || '') : '';
      if (!handle && card) {
        var qv = card.querySelector('[data-quick-view]');
        if (qv) handle = qv.getAttribute('data-quick-view') || '';
      }
      if (!handle && card) {
        var a = card.querySelector('.lumistelle-carousel__product-title a');
        var href = a && a.getAttribute('href');
        var mm = href && href.match(/\/products\/([^/?#]+)/);
        if (mm) handle = mm[1];
      }
      // No card: the PDP gallery heart and the quick-view heart both carry
      // .lumistelle-carousel__wishlist without sitting inside a product card.
      // Without a handle setLocal() silently stores nothing, which leaves the
      // heart permanently "saved" and the counter stuck at zero.
      if (!handle) {
        var host = btn.closest('[data-handle], [data-product-handle]');
        if (host) handle = host.getAttribute('data-handle') || host.getAttribute('data-product-handle') || '';
      }
      if (!handle) {
        var qv = btn.closest('.lumistelle-quickview');
        if (qv) {
          // Inside quick-view the URL is still the collection, so read the
          // product link the modal injects instead.
          var qa = qv.querySelector('a[href*="/products/"]');
          var qm = qa && qa.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (qm) handle = qm[1];
        } else {
          var pm = window.location.pathname.match(/\/products\/([^/?#]+)/);
          if (pm) handle = pm[1];
        }
      }
      if (id) toggle(id, handle);
    }, true);
  }

  // ---- Modal (Phase 3) ----
  var MODAL_ID = 'lumistelle-wishlist-modal';
  var GRID_ID = 'lumistelle-wm-grid';
  var modalOpen = false, modalClosing = false, engineInited = false, historyPushed = false, suppressPop = false;

  function modalEl() { return document.getElementById(MODAL_ID); }

  // #lumistelle-wm-content (empty state + grid) is one movable node. It lives in
  // the modal by default; the signed-in customer menu borrows it for its
  // Wishlist tab. appendChild moves it and keeps the engine instance + listeners.
  var CONTENT_ID = 'lumistelle-wm-content';
  function contentEl() { return document.getElementById(CONTENT_ID); }
  WL.mountContent = function (target) {
    var c = contentEl();
    if (c && target && c.parentNode !== target) target.appendChild(c);
  };

  var cardCache = {};        // handle -> HTML, per session
  var gridLoading = false;
  var restLoaded = false;
  var FETCH_BATCH = 10;      // cards fetched per batch

  function updateModalEmpty() {
    var c = contentEl(); if (!c) return;
    if (gridLoading) return;                  // cards still arriving
    var cards = c.querySelectorAll('.lumistelle-carousel__product');
    c.classList.toggle('lwm--empty', cards.length === 0);;
  }

  function fetchCard(handle) {
    if (cardCache[handle]) return Promise.resolve(cardCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '?view=wishlist-card', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('card_http_' + r.status); return r.text(); })
      .then(function (html) { cardCache[handle] = html; return html; });
  }

  function cardFromHTML(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.querySelector('.lumistelle-carousel__product');
  }

  // Batched append: firing a long list at once queues dozens of template renders
  // and holds the engine init until the last one lands.
  function appendCards(list, grid, afterFirstBatch) {
    var i = 0;
    function nextBatch() {
      if (i >= list.length) return Promise.resolve();
      var slice = list.slice(i, i + FETCH_BATCH);
      i += FETCH_BATCH;
      return Promise.all(slice.map(function (it) {
        if (grid.querySelector('.lumistelle-carousel__wishlist[data-product="' + it.id + '"]')) return Promise.resolve();
        return fetchCard(it.handle).then(function (html) {
          var el = cardFromHTML(html);
          if (el) grid.appendChild(el);
        }).catch(function () {});
      })).then(function () {
        WL.fill(grid);
        if (afterFirstBatch) { afterFirstBatch(); afterFirstBatch = null; }
        return nextBatch();
      });
    }
    return nextBatch();
  }

  function pruneGrid(grid, items) {
    var have = grid.querySelectorAll('.lumistelle-carousel__product');
    for (var i = have.length - 1; i >= 0; i--) {              // drop anything no longer saved
      var b = have[i].querySelector('.lumistelle-carousel__wishlist[data-product]');
      var pid = b && b.getAttribute('data-product'), keep = false;
      for (var j = 0; j < items.length; j++) { if (items[j].id === pid) { keep = true; break; } }
      if (!keep && have[i].parentNode) have[i].parentNode.removeChild(have[i]);
    }
  }

  function reorderGrid(grid, items) {
    for (var k = 0; k < items.length; k++) {                  // appendChild moves, keeps listeners
      var btn = grid.querySelector('.lumistelle-carousel__wishlist[data-product="' + items[k].id + '"]');
      var cardEl = btn && btn.closest('.lumistelle-carousel__product');
      if (cardEl) grid.appendChild(cardEl);
    }
  }

  // Guests have no SSR list — build the whole grid from localStorage, newest-first.
  // The engine inits after the first batch, so early cards are interactive at once.
  function renderGuestGrid() {
    var c = contentEl();
    var grid = c && c.querySelector('.lumistelle-grid__container');
    if (!grid) return Promise.resolve();
    var items = guestItems();
    gridLoading = true;
    c.classList.remove('lwm--empty');
    pruneGrid(grid, items);
    return appendCards(items, grid, initGridEngine).then(function () {
      reorderGrid(grid, items);
      gridLoading = false;
      updateModalEmpty();
    });
  }

  // Logged in: the first 10 cards are SSR'd; everything past that is listed on
  // the grid host and fetched here, on open, once per page load.
  function renderLoggedInRest() {
    if (restLoaded) return Promise.resolve();
    var c = contentEl();
    var grid = c && c.querySelector('.lumistelle-grid__container');
    var host = document.getElementById(GRID_ID);
    if (!grid || !host) return Promise.resolve();
    var rest = [];
    try { rest = JSON.parse(host.getAttribute('data-wl-rest') || '[]') || []; } catch (e) { rest = []; }
    rest = rest.filter(function (o) { return o && o.id && o.handle && WL.isWishlisted(o.id); });
    if (!rest.length) { restLoaded = true; return Promise.resolve(); }
    gridLoading = true;
    return appendCards(rest, grid, null).then(function () {
      restLoaded = true; gridLoading = false;
      updateModalEmpty();
    });
  }

  function removeFromModal(id) {
    var c = contentEl(); if (!c) return;
    var btns = c.querySelectorAll('.lumistelle-carousel__wishlist[data-product="' + id + '"]');
    for (var i = 0; i < btns.length; i++) {
      var card = btns[i].closest('.lumistelle-carousel__product');
      if (card && card.parentNode) card.parentNode.removeChild(card);
    }
    updateModalEmpty();
  }

  // Live-add a just-hearted product into the modal.
  // Fetches the canonical lite card rather than cloning the on-page one: a clone
  // may be the FULL card, whose extra elements are hidden only by section-scoped
  // CSS it leaves behind, and whose price is JS-hydrated.
  function addToModal(id, handle) {
    var c = contentEl(); if (!c || !handle) return;
    if (c.querySelector('.lumistelle-carousel__wishlist[data-product="' + id + '"]')) { updateModalEmpty(); return; }
    var grid = c.querySelector('.lumistelle-grid__container');
    if (!grid) return;
    fetchCard(handle).then(function (html) {
      if (!WL.isWishlisted(id)) return;                       // un-hearted while in flight
      if (grid.querySelector('.lumistelle-carousel__wishlist[data-product="' + id + '"]')) return;
      var el = cardFromHTML(html);
      if (!el) return;
      grid.insertBefore(el, grid.firstChild);                 // newest-first, matching the Worker + SSR
      WL.fill(el);
      updateModalEmpty();
    }).catch(function () { /* silent — SSR / guest render picks it up on next open */ });
  }

  var DISMISS_DIST = 180, DISMISS_VEL = 0.8, LOCK = 10;

  function initGridEngine() {
    var grid = document.getElementById(GRID_ID);
    if (grid && !engineInited && window.Lumistelle && window.Lumistelle.initLumistelleSection) {
      window.Lumistelle.initLumistelleSection(grid);
      engineInited = true;
    }
  }

  // Shared by every surface that shows the wishlist content (modal, customer menu).
  // Call after the content is mounted somewhere visible: the engine measures on init.
  WL.prepareGrid = function () {
    if (WL.loggedIn) {
      initGridEngine();
      updateModalEmpty();
      return renderLoggedInRest();              // cards 11+ arrive in batches
    }
    return renderGuestGrid();                   // engine inits after the first batch
  };
  WL.isModalOpen = function () { return modalOpen; };

  WL.openModal = function () {
    var m = modalEl(); if (!m || modalOpen || modalClosing) return;
    modalOpen = true;
    // Hand-off: close the customer menu without spending its history entry;
    // the history call below reuses that entry instead.
    var cm = window.LumistelleCustomerMenu;
    if (cm && cm.isOpen && cm.isOpen()) cm.close({ handoff: true });
    WL.mountContent(m.querySelector('.lwm__body'));   // take the content back if the menu borrowed it
    m.classList.add('lwm--mounted');            // display first, so the transition has a start frame
    WL.prepareGrid();
    document.documentElement.style.overflow = 'hidden';
    m.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { m.classList.add('lwm--open'); });   // ...then animate
    });
    try {
      if (history.state && history.state.lcm) history.replaceState({ lwm: true }, '');
      else history.pushState({ lwm: true }, '');
      historyPushed = true;
    } catch (e) {}
  };

  // Single close authority — teardown on transitionend, not a guessed timeout.
  WL.closeModal = function (fromPop) {
    var m = modalEl(); if (!m || !modalOpen || modalClosing) return;
    modalClosing = true;
    var sheet = m.querySelector('.lwm__sheet');
    m.classList.remove('lwm--dragging');        // restore the transition for the close glide
    m.classList.remove('lwm--open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    var done = false;
    function finish() {
      if (done) return; done = true;
      m.classList.remove('lwm--mounted');
      if (sheet) sheet.style.transform = '';    // clear any drag offset once hidden
      modalOpen = false; modalClosing = false;
    }
    if (sheet) sheet.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 450);                    // fallback
    if (historyPushed && !fromPop) {
      historyPushed = false; suppressPop = true;
      try { history.back(); } catch (e) { suppressPop = false; }
    } else { historyPushed = false; }
  };

  // Drag-to-close (cart-drawer pattern): engages on the header always, in the
  // scroll body only at the top, so it never fights the grid scroll.
  function wireDrag() {
    var m = modalEl(); if (!m) return;
    var sheet = m.querySelector('.lwm__sheet');
    var body = m.querySelector('.lwm__body');
    var header = m.querySelector('.lwm__header');
    if (!sheet) return;
    var startY = 0, startX = 0, lastY = 0, lastT = 0, vel = 0, delta = 0;
    var dragging = false, locked = false, engaged = false;

    sheet.addEventListener('touchstart', function (e) {
      if (!modalOpen || modalClosing || e.touches.length !== 1) return;
      var t = e.touches[0];
      startY = lastY = t.clientY; startX = t.clientX; lastT = Date.now();
      delta = 0; vel = 0; locked = false; dragging = false;
      engaged = (header && header.contains(e.target)) || !body || body.scrollTop <= 1;
    }, { passive: true });

    sheet.addEventListener('touchmove', function (e) {
      if (!engaged || !modalOpen || modalClosing) return;
      var t = e.touches[0];
      var dy = t.clientY - startY, dx = t.clientX - startX;
      if (!locked) {
        if (Math.abs(dy) < LOCK && Math.abs(dx) < LOCK) return;
        locked = true;
        if (Math.abs(dx) > Math.abs(dy) || dy < 0) { engaged = false; return; }  // horizontal or upward: not ours
        dragging = true;
        m.classList.add('lwm--dragging');
      }
      if (!dragging) return;
      var now = Date.now(), dt = now - lastT;
      if (dt > 0) vel = (t.clientY - lastY) / dt;
      lastY = t.clientY; lastT = now;
      delta = Math.max(0, dy);
      if (e.cancelable) e.preventDefault();
      sheet.style.transform = 'translateY(' + delta + 'px)';
    }, { passive: false });

    function end() {
      if (!dragging) { engaged = false; locked = false; return; }
      dragging = false; engaged = false; locked = false;
      m.classList.remove('lwm--dragging');
      if (delta > DISMISS_DIST || vel > DISMISS_VEL) {
        sheet.style.transform = 'translateY(105%)';   // continue the slide, no snap-back
        WL.closeModal();
      } else {
        sheet.style.transform = '';                   // settle back
      }
      delta = 0; vel = 0;
    }
    sheet.addEventListener('touchend', end);
    sheet.addEventListener('touchcancel', end);
  }

  function wireModal() {
    var m = modalEl(); if (!m) return;
    m.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-lwm-close]')) { e.preventDefault(); WL.closeModal(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modalOpen) WL.closeModal(); });
    window.addEventListener('popstate', function () {
      if (suppressPop) { suppressPop = false; return; }          // our own history.back()
      if (history.state && history.state.lwm) return;            // a modal above us closed; ours stays
      if (modalOpen) WL.closeModal(true);
    });
    wireDrag();
  }

  // ---- Header icon + count (mobile header badge and the desktop header bubble) ----
  function updateCount() {
    var n = WL.activeIds().length;
    var badges = document.querySelectorAll('.lumi-hdr__wishlist-btn .lumi-hdr__badge, .header__icon--wishlist .cart-count-bubble');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      badges[i].style.display = n > 0 ? '' : 'none';
    }
  }
  WL.updateCount = updateCount;

  function wireHeaderWishlist() {
    // Capture + stopPropagation: the header heart (mobile or desktop) only
    // ever opens our modal.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.lumi-hdr__wishlist-btn, .header__icon--wishlist') : null;
      if (!btn) return;
      if (btn.hasAttribute('data-lcm-toggle')) return;   // routed to the customer menu instead
      e.preventDefault(); e.stopPropagation();
      WL.openModal();
    }, true);
  }

  // ---- Guest -> login merge ----
  // A guest's list lives only in localStorage. On the first logged-in load we
  // hand it to the Worker, which unions it into the metafield (guest entries
  // first), then adopt the result as truth. localStorage is cleared only on
  // success, so a failed merge simply retries on the next load.
  var mergeDone = false;

  function idsFromGids(arr) {
    return (arr || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });
  }

  function mergeGuestOnLogin() {
    if (mergeDone || !WL.loggedIn) return;
    var items = guestItems();
    if (!items.length) return;
    mergeDone = true;

    fetch('/apps/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'merge', product_ids: items.map(function (o) { return o.id; }) })
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    }).then(function (d) {
      if (!d || !d.ok) throw new Error('merge_failed');
      var merged = idsFromGids(d.items);
      for (var i = 0; i < WL.ids.length; i++) {              // keep anything hearted mid-flight
        if (merged.indexOf(WL.ids[i]) === -1) merged.push(WL.ids[i]);
      }
      WL.ids = merged;
      try { localStorage.removeItem(GUEST_KEY); } catch (e) {}
      WL.fill(document);
      updateCount();
      // the modal SSR'd before the merge — pull the newly-merged cards in
      for (var j = items.length - 1; j >= 0; j--) addToModal(items[j].id, items[j].handle);
    }).catch(function () {
      mergeDone = false;                                     // guest list untouched; retry next load
    });
  }

  function init() {
    WL.fill(document); observeAppends(); wireClicks();
    wireModal(); wireHeaderWishlist(); updateCount();
    mergeGuestOnLogin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();